export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const scrollToIdWhenReady = (id, retries = 3) => {
  const el = document.getElementById(id);
  if (!el) {
    if (retries > 0) setTimeout(() => scrollToIdWhenReady(id, retries - 1), 200);
    return;
  }
  scrollToId(id);
  setTimeout(() => {
    const rect = el.getBoundingClientRect();
    if (Math.abs(rect.top - 72) > 200 && retries > 0) scrollToIdWhenReady(id, retries - 1);
  }, 1700);
};
